var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_2486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4563 10.2078C38.2516 8.50005 36.6423 6.86251 34.9584 6.64314C24.6906 5.36733 14.3076 5.36733 4.043 6.64314C2.35776 6.86204 0.74841 8.50005 0.543694 10.2078C-0.181191 16.4665 -0.181191 22.5349 0.543694 28.7922C0.74841 30.4999 2.35776 32.1389 4.043 32.3568C14.3076 33.6326 24.6909 33.6326 34.9584 32.3568C36.6423 32.1393 38.2516 30.4999 38.4563 28.7922C39.1813 22.5355 39.1813 16.4665 38.4563 10.2078ZM16.2498 26.0012V13.0008L26 19.5012L16.2498 26.0012Z",
    fill: "#A0A3BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_2486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.41708afe168ae07a75bd9a23088a76c3.svg";
export { ForwardRef as ReactComponent };